import { postDrcEnter, postDrcExit }  from '@/api/drc.ts';

export const postDrcEnterService = async (dock_sn) => {
    const client_id = localStorage.getItem("user_id");
    const payload = {
        "client_id": client_id,
        "dock_sn": dock_sn,
        "device_info": {
            "osd_frequency": 10,
            "hsi_frequency": 10,
        }
    }
    const result = await postDrcEnter(payload);
    return result;
}


export const postDrcExitService = async (dock_sn) => {
    const client_id = localStorage.getItem("user_id");
    const payload = {
        "client_id": client_id,
        "dock_sn": dock_sn,
    }
    const result = await postDrcExit(payload);
    return result;
}
